export const MathUtil = {
    formatNumberToLocaleString(number) {
        try {
            return number.toLocaleString('en-US');
        } catch (e) {
            return number
        }
    }
};